import { Injectable } from '@angular/core';
import { firstValueFrom, map, Observable } from 'rxjs';
import { PQRAlimentacaoEscolarDto } from '../../dtos/pqr-alimentacao-escolar.dto';
import { environment } from '../../../environments/environment';
import { CaqRequestService } from '../'

interface ListPQRAlimentacaoEscolar {
  _embedded: {
    'pqr-alimentacao-escolar': PQRAlimentacaoEscolarDto[];
  };
}

@Injectable({
  providedIn: 'root',
})
export class PQRAlimentacaoEscolarService {
  private apiUrl = `${environment.apiUrl}/pqr-alimentacao-escolar`;

  constructor(
    private caqRequestService: CaqRequestService
  ) {}

  buscarListaDePQRAlimentacaoEscolar(): Observable<PQRAlimentacaoEscolarDto[]> {
    return this.caqRequestService
      .get<ListPQRAlimentacaoEscolar>(this.apiUrl)
      .pipe(map((response) => response._embedded['pqr-alimentacao-escolar']));
  }

  salvePQRAlimentacaoEscolar(requisicao: PQRAlimentacaoEscolarDto){
    return firstValueFrom(this.caqRequestService
      .put<PQRAlimentacaoEscolarDto>(`${this.apiUrl}/${requisicao.codPqrAlimentacaoEscolar}`, requisicao)
      .pipe(map((response) => response)));
  }
}
